import React, { useState, useEffect } from 'react';
import { getDatabase, ref, set } from "firebase/database";
import { auth } from "./firebase";
import { 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  sendEmailVerification, 
  signOut,
  onAuthStateChanged,
  updateProfile,
} from "firebase/auth";
import LoginPage from "./LoginPage";
import SignupPage from "./SignupPage";
import Amain from "./Amain";
import logo from './asset/logo.png'
import CareerPage from "./Carrier.js";
import './Hero.css'
import Pilgarism from './Pilgarism.js'



import { Plus, Trash2, Download, FileText, LogOut, Menu, X, Mail, Lock, User, Sparkles, Zap, Shield, ArrowRight, CheckCircle, Star, Users, TrendingUp, Award, BarChart, Globe, Rocket, Check } from 'lucide-react';

const IEEEPaperWebsite = () => {
  const [currentPage, setCurrentPage] = useState('landing');
  const [user, setUser] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [activeSection, setActiveSection] = useState('home');
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showTermsOfService, setShowTermsOfService] = useState(false);
  const [showCookiePolicy, setShowCookiePolicy] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
      
      const sections = ['home', 'features', 'benefits', 'pricing', 'testimonials', 'contact'];
      const current = sections.find(section => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });
      if (current) setActiveSection(current);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [signupForm, setSignupForm] = useState({ name: '', email: '', password: '' });

  // Smooth form handlers
  const handleLoginChange = (field, value) => {
    setLoginForm(prev => ({ ...prev, [field]: value }));
  };

  const handleSignupChange = (field, value) => {
    setSignupForm(prev => ({ ...prev, [field]: value }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        loginForm.email,
        loginForm.password
      );

      if (userCredential.user.emailVerified) {
        setUser({
          name: loginForm.email.split('@')[0],
          email: loginForm.email
        });
        setCurrentPage('generator');
      } else {
        alert("Please verify your email before logging in.");
        await signOut(auth);
      }
      setLoginForm({ email: '', password: '' });
    } catch (err) {
      alert(err.message);
    }
  };

 const handleSignup = async (e, signupData) => {
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        signupData.email,
        signupData.password
      );
      
      // Save plan information to user profile or database
      await updateProfile(userCredential.user, {
        displayName: signupData.name
      });
      
      // Save plan to database
      const db = getDatabase();
      await set(ref(db, 'users/' + userCredential.user.uid + '/plan'), {
        plan: signupData.plan,
        planName: signupData.planName,
        subscribedAt: new Date().toISOString()
      });
      
      await sendEmailVerification(userCredential.user);
      alert("Verification email sent. Please check your inbox.");
      setSignupForm({ name: '', email: '', password: '' });
      setCurrentPage('login');
    } catch (err) {
      alert(err.message);
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    setUser(null);
    setCurrentPage('landing');
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false);
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      if (firebaseUser && firebaseUser.emailVerified) {
        setUser({ 
          name: firebaseUser.email.split('@')[0], 
          email: firebaseUser.email 
        });
        setCurrentPage("generator");
      } else {
        setUser(null);
      }
    });
    return () => unsubscribe();
  }, []);

  // Safe HTML escaping function without eval
  const escapeHtml = (text) => {
    if (!text) return '';
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };
    return text.replace(/[&<>"']/g, (m) => map[m]);
  };

  // New color scheme: Deep Blue + Emerald + Teal
  const AnimatedBackground = () => (
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-blue-950 to-emerald-950" />
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl animate-pulse" 
           style={{ animation: 'float 8s ease-in-out infinite' }} />
      <div className="absolute top-1/3 right-1/4 w-96 h-96 bg-emerald-500/20 rounded-full blur-3xl animate-pulse" 
           style={{ animation: 'float 10s ease-in-out infinite reverse' }} />
      <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-teal-500/20 rounded-full blur-3xl animate-pulse" 
           style={{ animation: 'float 12s ease-in-out infinite' }} />
    </div>
  );

  // Privacy Policy Modal Component
const PrivacyPolicyModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] overflow-hidden">
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-xl font-bold text-gray-800">Privacy Policy</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-lg"
          >
            ×
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[70vh]">
          <div className="prose max-w-none text-gray-700">
            <h3 className="text-lg font-semibold mb-4">Your Privacy Matters</h3>
            <p className="mb-4">
              At IeeeAssistant, we are committed to protecting your privacy and ensuring the security of your personal information.
            </p>
            
            <h4 className="font-semibold mt-6 mb-3">Information We Collect</h4>
            <ul className="list-disc list-inside space-y-2 mb-4">
              <li>Account information (email, name when provided)</li>
              <li>Papers and content you create on our platform</li>
              <li>Usage data and analytics to improve our service</li>
              <li>Payment information (handled securely by our payment processors)</li>
            </ul>

            <h4 className="font-semibold mt-6 mb-3">How We Use Your Information</h4>
            <ul className="list-disc list-inside space-y-2 mb-4">
              <li>To provide and maintain our IEEE paper generation service</li>
              <li>To process your transactions and manage your account</li>
              <li>To communicate with you about service updates and features</li>
              <li>To improve our platform and develop new features</li>
            </ul>

            <h4 className="font-semibold mt-6 mb-3">Data Security</h4>
            <p className="mb-4">
              We implement industry-standard security measures to protect your data. 
              Your papers and personal information are encrypted and stored securely.
            </p>

            <h4 className="font-semibold mt-6 mb-3">Third-Party Services</h4>
            <p className="mb-4">
              We use trusted third-party services for payment processing, analytics, 
              and cloud storage. These providers are bound by confidentiality agreements 
              and comply with data protection regulations.
            </p>

            <h4 className="font-semibold mt-6 mb-3">Your Rights</h4>
            <p className="mb-4">
              You have the right to access, correct, or delete your personal information. 
              You can manage your account settings or contact us directly for assistance.
            </p>

            <p className="text-sm text-gray-600 mt-8">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>
        </div>
        <div className="flex justify-end p-6 border-t">
          <button
            onClick={onClose}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

// Terms of Service Modal Component
const TermsOfServiceModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] overflow-hidden">
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-xl font-bold text-gray-800">Terms of Service</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-lg"
          >
            ×
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[70vh]">
          <div className="prose max-w-none text-gray-700">
            <h3 className="text-lg font-semibold mb-4">Welcome to IeeeAssistant</h3>
            <p className="mb-4">
              By using our IEEE paper generation service, you agree to these terms and conditions.
            </p>
            
            <h4 className="font-semibold mt-6 mb-3">Account Registration</h4>
            <ul className="list-disc list-inside space-y-2 mb-4">
              <li>You must provide accurate and complete registration information</li>
              <li>You are responsible for maintaining the security of your account</li>
              <li>You must be at least 13 years old to use our service</li>
              <li>One user per account - no sharing of login credentials</li>
            </ul>

            <h4 className="font-semibold mt-6 mb-3">Service Usage</h4>
            <ul className="list-disc list-inside space-y-2 mb-4">
              <li>Free tier includes basic paper generation features</li>
              <li>Premium features require subscription payment</li>
              <li>You retain ownership of the content you create</li>
              <li>We reserve the right to modify or discontinue features</li>
            </ul>

            <h4 className="font-semibold mt-6 mb-3">Prohibited Activities</h4>
            <ul className="list-disc list-inside space-y-2 mb-4">
              <li>Creating or distributing malicious or illegal content</li>
              <li>Attempting to reverse engineer or hack our platform</li>
              <li>Using automated scripts to access our service</li>
              <li>Violating intellectual property rights of others</li>
            </ul>

            <h4 className="font-semibold mt-6 mb-3">Payment and Billing</h4>
            <ul className="list-disc list-inside space-y-2 mb-4">
              <li>Subscriptions automatically renew unless canceled</li>
              <li>Refunds are available within 14 days of purchase</li>
              <li>We may change pricing with 30 days notice</li>
              <li>You can cancel your subscription at any time</li>
            </ul>

            <h4 className="font-semibold mt-6 mb-3">Limitation of Liability</h4>
            <p className="mb-4">
              IeeeAssistant is provided "as is" without warranties. We are not liable for 
              any damages resulting from use of our service. We make every effort to 
              ensure service availability but cannot guarantee uninterrupted access.
            </p>

            <h4 className="font-semibold mt-6 mb-3">Changes to Terms</h4>
            <p className="mb-4">
              We may update these terms periodically. Continued use of our service 
              after changes constitutes acceptance of the new terms.
            </p>

            <p className="text-sm text-gray-600 mt-8">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>
        </div>
        <div className="flex justify-end p-6 border-t">
          <button
            onClick={onClose}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

// Cookie Policy Modal Component
const CookiePolicyModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] overflow-hidden">
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-xl font-bold text-gray-800">Cookie Policy</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-lg"
          >
            ×
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[70vh]">
          <div className="prose max-w-none text-gray-700">
            <h3 className="text-lg font-semibold mb-4">Our Use of Cookies</h3>
            <p className="mb-4">
              We use cookies and similar technologies to enhance your experience on IeeeAssistant.
            </p>
            
            <h4 className="font-semibold mt-6 mb-3">What Are Cookies?</h4>
            <p className="mb-4">
              Cookies are small text files stored on your device that help us remember 
              your preferences and understand how you use our service.
            </p>

            <h4 className="font-semibold mt-6 mb-3">Types of Cookies We Use</h4>
            <ul className="list-disc list-inside space-y-2 mb-4">
              <li><strong>Essential Cookies:</strong> Required for basic functionality and security</li>
              <li><strong>Preference Cookies:</strong> Remember your settings and preferences</li>
              <li><strong>Analytics Cookies:</strong> Help us understand how users interact with our platform</li>
              <li><strong>Marketing Cookies:</strong> Used to deliver relevant advertisements</li>
            </ul>

            <h4 className="font-semibold mt-6 mb-3">Managing Cookies</h4>
            <p className="mb-4">
              You can control cookie settings through your browser. However, disabling 
              essential cookies may affect the functionality of our service.
            </p>

            <h4 className="font-semibold mt-6 mb-3">Third-Party Cookies</h4>
            <p className="mb-4">
              We may use third-party services that set their own cookies for analytics 
              and advertising purposes.
            </p>

            <p className="text-sm text-gray-600 mt-8">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>
        </div>
        <div className="flex justify-end p-6 border-t">
          <button
            onClick={onClose}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

  // Landing Page
  const LandingPage = () => (
    <div className="relative min-h-screen bg-black overflow-hidden">
      <AnimatedBackground />
      
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrollY > 50 ? 'bg-black/80 backdrop-blur-xl border-b border-white/10' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
              <div className="relative">
               <img
    src={logo} // replace with your image path
    alt="Description"
    width="100px"
  />
                <div className="absolute inset-0 bg-blue-500/30 blur-xl rounded-full" />
              </div>
              <span className="text-white font-bold text-2xl bg-gradient-to-r from-blue-400 to-emerald-400 bg-clip-text text-transparent">
                IeeeAssistant
              </span>
            </div>
            
            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center gap-8">
              {['home', 'features', 'benefits', 'pricing', 'testimonials', 'contact'].map((item) => (
                <button
                  key={item}
                  onClick={() => scrollToSection(item)}
                  className={`text-sm font-medium transition-all duration-300 ${
                    activeSection === item 
                      ? 'text-white scale-110' 
                      : 'text-white/60 hover:text-white'
                  }`}
                >
                  {item.charAt(0).toUpperCase() + item.slice(1)}
                </button>
              ))}
           <button
  onClick={() => setCurrentPage("carrier")}
  className={`text-sm font-medium transition-all duration-300 ${
    currentPage === "carrier" 
      ? "text-white scale-110" 
      : "text-white/60 hover:text-white"
  }`}
>
  Careers
</button>

              <button
                onClick={() => setCurrentPage('login')}
                className="text-white/90 hover:text-white transition text-sm font-medium"
              >
                Login
              </button>
              <button
                onClick={() => setCurrentPage('signup')}
                className="relative group"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-emerald-600 rounded-full blur-lg opacity-75 group-hover:opacity-100 transition" />
                <div className="relative bg-gradient-to-r from-blue-600 to-emerald-600 text-white px-6 py-2.5 rounded-full font-semibold text-sm">
                  Get Started
                </div>
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setMenuOpen(!menuOpen)} className="lg:hidden text-white">
              {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>

          {/* Mobile Menu */}
          {menuOpen && (
            <div className="lg:hidden pb-6 space-y-4 animate-fadeIn">
              {['home', 'features', 'benefits', 'pricing', 'testimonials', 'contact'].map((item) => (
                <button
                  key={item}
                  onClick={() => scrollToSection(item)}
                  className="block w-full text-left text-white/90 hover:text-white py-2 text-sm font-medium"
                >
                  {item.charAt(0).toUpperCase() + item.slice(1)}
                </button>
              ))}
             <button
  onClick={() => setCurrentPage("carrier")}
  className={`text-sm font-medium transition-all duration-300 ${
    currentPage === "carrier" 
      ? "text-white scale-110" 
      : "text-white/60 hover:text-white"
  }`}
>
  Careers
</button>

              <button
                onClick={() => { setCurrentPage('login'); setMenuOpen(false); }}
                className="block w-full text-left text-white/90 hover:text-white py-2 text-sm font-medium"
              >
                Login
              </button>
              <button
                onClick={() => { setCurrentPage('signup'); setMenuOpen(false); }}
                className="block w-full bg-gradient-to-r from-blue-600 to-emerald-600 text-white px-6 py-2 rounded-full font-semibold text-sm"
              >
                Get Started
              </button>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
 <section id="home" className="relative min-h-screen flex items-center justify-center px-4 pt-20">
  <div className="max-w-7xl mx-auto text-center">
    <div className="inline-flex items-center gap-2 bg-white/5 backdrop-blur-sm border border-white/10 rounded-full px-6 py-3 mb-8 animate-fadeIn">
      <Sparkles className="w-5 h-5 text-emerald-400 animate-pulse" />
      <span className="text-white text-sm font-medium">Trusted by 50,000+ Researchers</span>
    </div>
   
    
    <h1 className="text-6xl md:text-8xl font-black text-white mb-8 leading-tight animate-fadeIn" style={{ animationDelay: '0.1s' }}>
      Create <span className="relative inline-block">
        <span className="relative z-10">IEEE Paper</span>
        {/* Pen-marked underline effect */}
        <div className="absolute bottom-2 left-0 right-0 h-4 bg-gradient-to-r from-blue-400/30 to-emerald-400/30 transform rotate-[-2deg] rounded-lg blur-[1px]"></div>
        <div className="absolute bottom-1 left-2 right-2 h-3 bg-gradient-to-r from-blue-500/40 to-emerald-500/40 transform rotate-[1deg] rounded-md"></div>
        <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-r from-blue-400 to-emerald-400 transform rotate-[-1deg] rounded-sm"></div>
      </span>s
      <br />
      <span className="relative inline-block mt-4">
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-emerald-400 to-teal-400 animate-gradient">
          Effortlessly
        </span>
        <div className="absolute -inset-1 bg-gradient-to-r from-blue-600/50 to-emerald-600/50 blur-2xl -z-10 animate-pulse" />
      </span>
    </h1>
    
    
    <p className="text-xl md:text-2xl text-white/70 mb-12 max-w-3xl mx-auto animate-fadeIn" style={{ animationDelay: '0.2s' }}>
      The world's most advanced IEEE paper generator. From draft to publication in minutes, 
      not weeks. No LaTeX expertise required.
    </p>

    <div className="flex flex-col sm:flex-row gap-6 justify-center mb-8 animate-fadeIn" style={{ animationDelay: '0.3s' }}>
      <button
        onClick={() => setCurrentPage('signup')}
        className="group relative"
      >
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-emerald-600 rounded-2xl blur-xl opacity-75 group-hover:opacity-100 transition animate-pulse" />
        <div className="relative bg-gradient-to-r from-blue-600 to-emerald-600 text-white px-10 py-5 rounded-2xl font-bold text-lg flex items-center justify-center gap-3 transform group-hover:scale-105 transition">
          Start Creating Free
          <ArrowRight className="w-6 h-6 group-hover:translate-x-2 transition" />
        </div>
      </button>
      <button
        onClick={() => scrollToSection('features')}
        className="relative group"
      >
        <div className="absolute inset-0 bg-white/5 rounded-2xl blur-lg" />
        <div className="relative bg-white/10 backdrop-blur-sm border-2 border-white/20 text-white px-10 py-5 rounded-2xl font-bold text-lg hover:bg-white/20 transition">
          Explore Features
        </div>
      </button>
    </div>
      {/* Powered by section */}
   <div className="animate-fadeIn" style={{ animationDelay: '0.5s', border:'1px  solid black', padding: '5px', borderRadius:'10px', marginBottom:'5%' }}>
  <div className="inline-flex items-center gap-2 bg-gradient-to-r from-black/40 to-black/30 backdrop-blur-md border border-white/20 rounded-full px-6 py-3 shadow-lg hover:shadow-xl hover:border-white/30 transition-all duration-300">
    <span className="text-white/70 text-sm font-medium">Powered by</span>
    <a 
      href="https://engneeringpc.web.app/" 
      target="_blank" 
      rel="noopener noreferrer"
      className="text-white font-semibold text-sm hover:text-blue-300 transition-colors duration-200 flex items-center gap-1 group"
    >
      <span>Engineering Project Consultancy</span>
      <svg 
        className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-200" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
      </svg>
    </a>
  </div>
  
  <div className="mt-1 animate-fadeIn"  >
    <p className="text-white/80 text-base md:text-lg leading-relaxed max-w-2xl mx-auto text-center">
      We design and develop{' '}
      <span className="text-white font-semibold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
        all engineering projects (AI,IOT,Mechinical,Electronics,Eletrical,Deeplearning)
      </span>
      {' '}and{' '}
      <span className="text-white font-semibold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
        commercial projects
      </span>
    </p>
  </div>
</div>
    {/* Stats */}
    <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto animate-fadeIn mb-12" style={{ animationDelay: '0.4s' }}>
      {[
        { icon: Users, value: '50K+', label: 'Active Users' },
        { icon: FileText, value: '200K+', label: 'Papers Generated' },
        { icon: Award, value: '98%', label: 'Satisfaction Rate' },
        { icon: Globe, value: '150+', label: 'Countries' }
      ].map((stat, idx) => (
        <div key={idx} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition transform hover:scale-105">
          <stat.icon className="w-8 h-8 text-blue-400 mx-auto mb-3" />
          <div className="text-3xl font-bold text-white mb-1">{stat.value}</div>
          <div className="text-sm text-white/60">{stat.label}</div>
        </div>
      ))}
    </div>

  </div>
</section>

      {/* Features Section */}
  
      <section id="features" className="relative py-32 px-4">
   
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-5xl md:text-6xl font-black text-white mb-6">
              Powerful Features
            </h2>
            <p className="text-xl text-white/70 max-w-2xl mx-auto">
              Everything you need to create professional IEEE papers
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                icon: Zap,
                title: 'Lightning Fast',
                description: 'Generate publication-ready papers in seconds. Our AI-powered engine handles all the formatting complexities.',
                gradient: 'from-blue-500 to-cyan-600'
              },
              {
                icon: Shield,
                title: '100% IEEE Compliant',
                description: 'Pixel-perfect adherence to IEEE formatting standards. Every paper meets strict publication guidelines.',
                gradient: 'from-emerald-500 to-teal-600'
              },
              {
                icon: FileText,
                title: 'Intuitive Interface',
                description: 'No LaTeX knowledge needed. Simple form-based input with real-time preview and instant export.',
                gradient: 'from-sky-500 to-blue-600'
              },
              {
                icon: BarChart,
                title: 'Smart Citations',
                description: 'Automatic reference formatting and citation management. Focus on content, not formatting.',
                gradient: 'from-green-500 to-emerald-600'
              },
              {
                icon: TrendingUp,
                title: 'Version Control',
                description: 'Track changes, collaborate with team members, and maintain multiple paper versions effortlessly.',
                gradient: 'from-teal-500 to-cyan-600'
              },
              {
                icon: Rocket,
                title: 'Export Options',
                description: 'Download as PDF, LaTeX, or Word. Compatible with all major submission platforms.',
                gradient: 'from-indigo-500 to-blue-600'
              }
            ].map((feature, idx) => (
              <div
                key={idx}
                className="group relative bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-8 hover:bg-white/10 transition-all duration-500 transform hover:-translate-y-4"
                style={{ animationDelay: `${idx * 0.1}s` }}
              >
                <div className={`bg-gradient-to-br ${feature.gradient} w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                  <feature.icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-4">{feature.title}</h3>
                <p className="text-white/70 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section id="benefits" className="relative py-32 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-5xl md:text-6xl font-black text-white mb-6">
              Why Choose Us?
            </h2>
            <p className="text-xl text-white/70 max-w-2xl mx-auto">
              Join thousands of researchers who trust IEEE Paper Pro
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12">
            <div className="space-y-8">
              {[
                { title: 'Save 90% of Your Time', desc: 'What used to take days now takes minutes. Focus on research, not formatting.' },
                { title: 'Zero Learning Curve', desc: 'Start creating immediately. No tutorials, no manuals, no complexity.' },
                { title: 'Professional Results', desc: 'Every paper looks like it was crafted by a LaTeX expert.' },
                { title: 'Universal Compatibility', desc: 'Works with IEEE Xplore, arXiv, and all major submission systems.' }
              ].map((benefit, idx) => (
                <div key={idx} className="flex gap-6 group">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-emerald-500 flex items-center justify-center group-hover:scale-110 transition">
                      <CheckCircle className="w-6 h-6 text-white" />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white mb-2">{benefit.title}</h3>
                    <p className="text-white/70 text-lg">{benefit.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-600/20 to-emerald-600/20 rounded-3xl blur-3xl" />
              <div className="relative bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-12">
                <div className="space-y-6">
                  <div className="bg-gradient-to-br from-blue-500/20 to-emerald-500/20 rounded-2xl p-6 border border-blue-500/20">
                    <h4 className="text-white font-bold text-xl mb-2">Traditional Method</h4>
                    <p className="text-white/60">5-7 days of LaTeX formatting</p>
                  </div>
                  <div className="flex justify-center">
                    <ArrowRight className="w-8 h-8 text-blue-400 rotate-90" />
                  </div>
                  <div className="bg-gradient-to-br from-emerald-500/20 to-teal-500/20 rounded-2xl p-6 border border-emerald-500/20">
                    <h4 className="text-white font-bold text-xl mb-2">With IEEE Paper Pro</h4>
                    <p className="text-white/60">5 minutes from start to finish</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="relative py-32 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-5xl md:text-6xl font-black text-white mb-6">
              Simple Pricing
            </h2>
            <p className="text-xl text-white/70 max-w-2xl mx-auto">
              Choose the plan that fits your research needs
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                name: 'Freeminum',
                price: '₹0',
                period: 'forever',
                features: [
                  'Unlimited papers',
                  'Basic formatting',
                  'PDF export',
                  'Email support',
                ],
                popular: false
              },
              {
                name: 'Basimeum (comming soon)',
                price: '₹99',
                period: 'per month',
                features: [
                  'Unlimited papers',
                  'Advanced formatting',
                  'Priority support',
                  '5 Plagiarism checker',
                  '10 AI content generation',
                  'limited Team collaboration',
                ],
                popular: true
              },
              {
                name: 'Preminum (comming soon)',
                price: '₹499',
                period: 'per month',
                features: [
                  'Everything in Pro',
                  'Unlimited team members',
                  'Dedicated support',
                  'Custom integrations',
                  '28 Plagiarism checker',
                  '50 AI content generation',
                ],
                popular: false
              }
            ].map((plan, idx) => (
              <div
                key={idx}
                className={`relative bg-white/5 backdrop-blur-xl border ${
                  plan.popular ? 'border-blue-500/50 scale-105' : 'border-white/10'
                } rounded-3xl p-8 hover:bg-white/10 transition-all duration-500 transform hover:-translate-y-2`}
              >
                {plan.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <div className="bg-gradient-to-r from-blue-600 to-emerald-600 text-white text-sm font-bold px-6 py-2 rounded-full">
                      MOST POPULAR
                    </div>
                  </div>
                )}
                <div className="text-center mb-8">
                  <h3 className="text-2xl font-bold text-white mb-4">{plan.name}</h3>
                  <div className="flex items-baseline justify-center gap-2 mb-2">
                    <span className="text-5xl font-black text-white">{plan.price}</span>
                    <span className="text-white/60">{plan.period}</span>
                  </div>
                </div>
                <ul className="space-y-4 mb-8">
                  {plan.features.map((feature, fidx) => (
                    <li key={fidx} className="flex items-center gap-3">
                      <Check className="w-5 h-5 text-emerald-400 flex-shrink-0" />
                      <span className="text-white/80">{feature}</span>
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => setCurrentPage('signup')}
                  className={`w-full py-4 rounded-xl font-bold transition ${
                    plan.popular
                      ? 'bg-gradient-to-r from-blue-600 to-emerald-600 text-white hover:shadow-2xl'
                      : 'bg-white/10 text-white hover:bg-white/20'
                  }`}
                >
                  Get Started
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="relative py-32 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-5xl md:text-6xl font-black text-white mb-6">
              Loved by Researchers
            </h2>
            <p className="text-xl text-white/70 max-w-2xl mx-auto">
              See what our community has to say
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                name: 'Dr. Sarah Chen',
                role: 'AI Researcher, MIT',
                image: '👩‍🔬',
                rating: 5,
                text: 'This tool has revolutionized my publication workflow. What used to take me a week now takes 10 minutes. Absolutely game-changing!'
              },
              {
                name: 'Prof. James Wilson',
                role: 'Computer Science, Stanford',
                image: '👨‍💻',
                rating: 5,
                text: 'The plagiarism checker in the Pro version is incredibly accurate. It has saved my team countless hours of manual checking.'
              },
              {
                name: 'Dr. Maria Garcia',
                role: 'Engineering, Cambridge',
                image: '👩‍🏫',
                rating: 5,
                text: 'IEEE Paper Pro is now an essential part of our research lab. The collaboration features make team projects seamless.'
              }
            ].map((testimonial, idx) => (
              <div
                key={idx}
                className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-8 hover:bg-white/10 transition transform hover:-translate-y-2"
              >
                <div className="flex items-center gap-4 mb-6">
                  <div className="text-5xl">{testimonial.image}</div>
                  <div>
                    <h4 className="text-white font-bold text-lg">{testimonial.name}</h4>
                    <p className="text-white/60 text-sm">{testimonial.role}</p>
                  </div>
                </div>
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-emerald-400 text-emerald-400" />
                  ))}
                </div>
                <p className="text-white/80 leading-relaxed">{testimonial.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="relative py-32 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-5xl md:text-6xl font-black text-white mb-6">
              Get in Touch
            </h2>
            <p className="text-xl text-white/70">
              Have questions? We'd love to hear from you
            </p>
          </div>

          <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-12">
            <form className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="contact-name" className="block text-white text-sm font-medium mb-2">
                    Your Name
                  </label>
                  <input
                    id="contact-name"
                    name="name"
                    type="text"
                    placeholder="Your Name"
                    className="w-full px-6 py-4 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                  />
                </div>
                <div>
                  <label htmlFor="contact-email" className="block text-white text-sm font-medium mb-2">
                    Your Email
                  </label>
                  <input
                    id="contact-email"
                    name="email"
                    type="email"
                    placeholder="Your Email"
                    className="w-full px-6 py-4 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                  />
                </div>
              </div>
              <div>
                <label htmlFor="contact-subject" className="block text-white text-sm font-medium mb-2">
                  Subject
                </label>
                <input
                  id="contact-subject"
                  name="subject"
                  type="text"
                  placeholder="Subject"
                  className="w-full px-6 py-4 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                />
              </div>
              <div>
                <label htmlFor="contact-message" className="block text-white text-sm font-medium mb-2">
                  Your Message
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  rows={6}
                  placeholder="Your Message"
                  className="w-full px-6 py-4 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200 resize-none"
                />
              </div>
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-blue-600 to-emerald-600 text-white py-4 rounded-xl font-bold text-lg hover:shadow-2xl transition transform hover:scale-105"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
   <footer className="relative border-t border-white/10 bg-black/40 backdrop-blur-md py-12 px-4">
  <div className="max-w-7xl mx-auto">
    <div className="grid md:grid-cols-4 gap-8 mb-8">
      {/* Company Brand Section */}
      <div className="md:col-span-2">
        <div className="flex items-center gap-2 mb-4">
          <span className="text-white font-bold text-xl">IEEE Assistant</span>
        </div>
        <p className="text-white/60 text-sm mb-4">
          The world's most advanced IEEE paper formatting and generation platform. 
          Streamline your research publication process with AI-powered tools.
        </p>
        <div className="text-white/50 text-xs">
          <p className="font-semibold text-white/70 mb-1">A Product of</p>
          <p className="text-blue-300">scopewit sp.zo.o. technologies pvt. ltd.</p>
          <p className="mt-2">Innovating the future of academic research and publishing</p>
        </div>
      </div>

      {/* Product Section */}
      <div>
        <h4 className="text-white font-bold mb-4">Product</h4>
        <ul className="space-y-2 text-white/60 text-sm">
          <li><button onClick={() => scrollToSection('features')} className="hover:text-blue-400 transition-colors">Features</button></li>
          <li><button onClick={() => scrollToSection('pricing')} className="hover:text-blue-400 transition-colors">Pricing</button></li>
          <li><button onClick={() => scrollToSection('testimonials')} className="hover:text-blue-400 transition-colors">Testimonials</button></li>
          {/* <li><button onClick={() => scrollToSection('templates')} className="hover:text-blue-400 transition-colors">Templates</button></li> */}
          <li><a href="/blog" className="hover:text-blue-400 transition-colors">Blog & Resources</a></li>
        </ul>
      </div>

      {/* Company & Support Section */}
      <div>
        <h4 className="text-white font-bold mb-4">Company & Support</h4>
        <ul className="space-y-2 text-white/60 text-sm">
          <li><a href="/about" className="hover:text-blue-400 transition-colors">About Us</a></li>
          <li><a href="/job" className="hover:text-blue-400 transition-colors">Careers</a></li>
          <li><a href="/contact" className="hover:text-blue-400 transition-colors">Contact</a></li>
          {/* <li><a href="/support" className="hover:text-blue-400 transition-colors">Support Center</a></li> */}
          {/* <li><a href="/documentation" className="hover:text-blue-400 transition-colors">Documentation</a></li> */}
        </ul>
        
        {/* Social Media Links - Text Only */}
        <div className="mt-6 flex space-x-4">
          <a href="#" className="text-white/60 hover:text-blue-400 transition-colors text-sm">
            Twitter
          </a>
          <a href="#" className="text-white/60 hover:text-blue-400 transition-colors text-sm">
            LinkedIn
          </a>
          <a href="#" className="text-white/60 hover:text-blue-400 transition-colors text-sm">
            GitHub
          </a>
        </div>
      </div>
    </div>

    {/* Legal & Additional Links */}
    <div className="border-t border-white/10 pt-8">
      <div className="grid md:grid-cols-2 gap-8">
        {/* Legal Links */}
        <div>
          <h4 className="text-white font-bold mb-4">Legal</h4>
          <div className="grid grid-cols-2 gap-4 text-white/60 text-sm">
            <div>
              <ul className="space-y-2">
                <li><a href="/privacy" className="hover:text-blue-400 transition-colors">Privacy Policy</a></li>
                <li><a href="/terms" className="hover:text-blue-400 transition-colors">Terms of Service</a></li>
                <li><a href="/cookies" className="hover:text-blue-400 transition-colors">Cookie Policy</a></li>
              </ul>
            </div>
            <div>
              <ul className="space-y-2">
                <li><a href="/refunds" className="hover:text-blue-400 transition-colors">Cancellation & Refunds</a></li>
                <li><a href="/shipping" className="hover:text-blue-400 transition-colors">Shipping Policy</a></li>
                <li><a href="/gdpr" className="hover:text-blue-400 transition-colors">GDPR Compliance</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Contact & Business Info */}
        <div>
          <h4 className="text-white font-bold mb-4">Business Information</h4>
          <div className="text-white/60 text-sm space-y-2">
            <p><strong>Parent Company:</strong> scopewit sp.zo.o. technologies pvt. ltd.</p>
            <p><strong>Email:</strong> support@ieeeassistant.in</p>
            <p><strong>Business Hours:</strong> Mon-Fri, 9AM-6PM IST</p>
            <p><strong>Support:</strong> 24/7 Technical Support Available</p>
          </div>
        </div>
      </div>
    </div>

    {/* Bottom Copyright */}
    <div className="border-t border-white/10 pt-8 mt-8">
      <div className="flex flex-col md:flex-row justify-between items-center">
        <p className="text-white/60 text-sm mb-4 md:mb-0">
          © 2025 IEEE Assistant. All rights reserved. 
          <span className="ml-2 text-white/40">A product of scopewit sp.zo.o. technologies pvt. ltd.</span>
        </p>
        
        {/* Trust Badges */}
        <div className="flex items-center space-x-4 text-xs text-white/40">
          <span>🔒 SSL Secured</span>
          <span>⭐ Trusted by Researchers</span>
          <span>🌐 Global Service</span>
        </div>
      </div>
    </div>
  </div>
</footer>


      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0) translateX(0); }
          50% { transform: translateY(-20px) translateX(10px); }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-fadeIn {
          animation: fadeIn 0.8s ease-out forwards;
        }
        .animate-gradient {
          background-size: 200% 200%;
          animation: gradient 3s ease infinite;
        }
      `}</style>
    </div>
  );

  // Generator Page
  const GeneratorPage = () => {
    const [formData, setFormData] = useState({
      title: '',
      authors: [''],
      affiliations: [''],
      emails: [''],
      abstract: '',
      keywords: '',
      sections: [{ heading: '', content: '' }],
      references: ['']
    });

    const [generating, setGenerating] = useState(false);

    const handleChange = (field, value) => {
      setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleArrayChange = (field, index, value) => {
      const newArray = [...formData[field]];
      newArray[index] = value;
      setFormData(prev => ({ ...prev, [field]: newArray }));
    };

    const handleSectionChange = (index, field, value) => {
      const newSections = [...formData.sections];
      newSections[index][field] = value;
      setFormData(prev => ({ ...prev, sections: newSections }));
    };

    const addItem = (field) => {
      if (field === 'sections') {
        setFormData(prev => ({
          ...prev,
          [field]: [...prev[field], { heading: '', content: '' }]
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          [field]: [...prev[field], '']
        }));
      }
    };

    const removeItem = (field, index) => {
      const newArray = formData[field].filter((_, i) => i !== index);
      setFormData(prev => ({ ...prev, [field]: newArray }));
    };

    const generatePDF = async () => {
      setGenerating(true);
      try {
        const htmlContent = generateIEEEHTML(formData);
        
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.width = '210mm';
        iframe.style.height = '297mm';
        iframe.style.left = '-9999px';
        document.body.appendChild(iframe);
        
        const iframeDoc = iframe.contentWindow.document;
        iframeDoc.open();
        iframeDoc.write(htmlContent);
        iframeDoc.close();
        
        await new Promise(resolve => setTimeout(resolve, 500));
        
        iframe.contentWindow.print();
        
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 1000);
        
      } catch (error) {
        alert('Error generating PDF: ' + error.message);
      } finally {
        setGenerating(false);
      }
    };

    const generateIEEEHTML = (data) => {
      return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>${data.title}</title>
  <style>
    @page {
      size: A4;
      margin: 19mm 14.32mm 43mm 14.32mm;
    }
    
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
    
    body {
      font-family: 'Times New Roman', Times, serif;
      font-size: 10pt;
      line-height: 1.2;
      color: #000;
      background: white;
    }
    
    .page-container {
      width: 210mm;
      min-height: 297mm;
      margin: 0 auto;
      background: white;
      padding: 19mm 14.32mm 43mm 14.32mm;
    }
    
    .title {
      font-size: 24pt;
      font-weight: bold;
      text-align: center;
      margin-bottom: 12pt;
      line-height: 1.1;
    }
    
    .authors {
      font-size: 11pt;
      text-align: center;
      margin-bottom: 8pt;
    }
    
    .affiliations {
      font-size: 10pt;
      font-style: italic;
      text-align: center;
      margin-bottom: 6pt;
    }
    
    .emails {
      font-family: 'Courier New', Courier, monospace;
      font-size: 9pt;
      text-align: center;
      margin-bottom: 16pt;
    }
    
    .abstract-section {
      margin-bottom: 16pt;
    }
    
    .abstract-heading {
      font-size: 9pt;
      font-weight: bold;
      font-style: italic;
      margin-bottom: 6pt;
    }
    
    .abstract-body {
      font-size: 9pt;
      text-align: justify;
      text-justify: inter-word;
      line-height: 1.3;
      margin-bottom: 8pt;
    }
    
    .keywords {
      font-size: 9pt;
      font-style: italic;
    }
    
    .keywords strong {
      font-weight: bold;
      font-style: italic;
    }
    
    .two-column {
      column-count: 2;
      column-gap: 4.22mm;
      margin-top: 16pt;
    }
    
    .section {
      break-inside: avoid;
      margin-bottom: 12pt;
    }
    
    .section-heading {
      font-size: 10pt;
      font-weight: bold;
      font-variant: small-caps;
      margin-bottom: 6pt;
      margin-top: 8pt;
    }
    
    .section-content {
      font-size: 10pt;
      text-align: justify;
      text-justify: inter-word;
      line-height: 1.3;
    }
    
    .references-section {
      margin-top: 16pt;
    }
    
    .references-heading {
      font-size: 10pt;
      font-weight: bold;
      font-variant: small-caps;
      margin-bottom: 8pt;
    }
    
    .reference-item {
      font-size: 8pt;
      margin-bottom: 4pt;
      text-align: justify;
      padding-left: 16pt;
      text-indent: -16pt;
      line-height: 1.2;
    }
    
    .reference-number {
      font-weight: bold;
    }
    
    @media print {
      body {
        margin: 0;
        padding: 0;
      }
      
      .page-container {
        margin: 0;
        padding: 19mm 14.32mm 43mm 14.32mm;
        page-break-after: always;
      }
      
      .no-break {
        page-break-inside: avoid;
      }
    }
  </style>
</head>
<body>
  <div class="page-container">
    <div class="title">${escapeHtml(data.title)}</div>
    
    <div class="authors">
      ${data.authors.filter(a => a.trim()).map(a => escapeHtml(a)).join(', ')}
    </div>
    
    <div class="affiliations">
      ${data.affiliations.filter(a => a.trim()).map(a => escapeHtml(a)).join(', ')}
    </div>
    
    <div class="emails">
      ${data.emails.filter(e => e.trim()).map(e => escapeHtml(e)).join(', ')}
    </div>
    
    <div class="abstract-section">
      <div class="abstract-heading">Abstract</div>
      <div class="abstract-body">
        ${escapeHtml(data.abstract)}
      </div>
      ${data.keywords ? `
      <div class="keywords">
        <strong>Keywords—</strong>${escapeHtml(data.keywords)}
      </div>
      ` : ''}
    </div>
    
    <div class="two-column">
      ${data.sections.filter(s => s.heading.trim() || s.content.trim()).map((section, idx) => `
        <div class="section">
          <div class="section-heading">${idx + 1}. ${escapeHtml(section.heading)}</div>
          <div class="section-content">${escapeHtml(section.content).replace(/\n/g, '<br>')}</div>
        </div>
      `).join('')}
      
      ${data.references.filter(r => r.trim()).length > 0 ? `
        <div class="references-section">
          <div class="references-heading">References</div>
          ${data.references.filter(r => r.trim()).map((ref, idx) => `
            <div class="reference-item">
              <span class="reference-number">[${idx + 1}]</span> ${escapeHtml(ref)}
            </div>
          `).join('')}
        </div>
      ` : ''}
    </div>
  </div>
</body>
</html>
      `;
    };

    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
        <nav className="bg-white shadow-sm border-b sticky top-0 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <div className="flex items-center gap-2">
                <FileText className="w-8 h-8 text-blue-600" />
                <span className="font-bold text-xl text-gray-800">IEEE Paper Pro</span>
              </div>
              
              <div className="flex items-center gap-4">
                <span className="text-gray-600 hidden sm:inline">Welcome, {user.name}!</span>
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-2 text-gray-600 hover:text-gray-800 transition"
                >
                  <LogOut className="w-5 h-5" />
                  <span className="hidden sm:inline">Logout</span>
                </button>
              </div>
            </div>
          </div>
        </nav>

        <div className="py-8 px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-r from-blue-600 to-emerald-600 rounded-2xl shadow-xl p-8 mb-8 text-white">
              <div className="flex items-center gap-4 mb-4">
                <FileText className="w-12 h-12" />
                <div>
                  <h1 className="text-4xl font-bold">IEEE Research Paper Generator</h1>
                  <p className="text-blue-100">Generate professionally formatted IEEE conference papers</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-xl p-8 space-y-8">
              <div>
                <label htmlFor="paper-title" className="block text-sm font-semibold text-gray-700 mb-2">
                  Paper Title *
                </label>
                <input
                  id="paper-title"
                  name="title"
                  type="text"
                  value={formData.title}
                  onChange={(e) => handleChange('title', e.target.value)}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                  placeholder="Enter your paper title"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Authors *</label>
                {formData.authors.map((author, idx) => (
                  <div key={idx} className="flex gap-2 mb-3">
                    <input
                      id={`author-${idx}`}
                      name={`author-${idx}`}
                      type="text"
                      value={author}
                      onChange={(e) => handleArrayChange('authors', idx, e.target.value)}
                      className="flex-1 px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      placeholder={`Author ${idx + 1}`}
                      required
                    />
                    {formData.authors.length > 1 && (
                      <button
                        onClick={() => removeItem('authors', idx)}
                        className="p-3 text-red-600 hover:bg-red-50 rounded-xl transition"
                        type="button"
                      >
                        <Trash2 className="w-5 h-5" />
                      </button>
                    )}
                  </div>
                ))}
                <button
                  onClick={() => addItem('authors')}
                  className="flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium transition"
                  type="button"
                >
                  <Plus className="w-5 h-5" /> Add Author
                </button>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Affiliations *</label>
                {formData.affiliations.map((affiliation, idx) => (
                  <div key={idx} className="flex gap-2 mb-3">
                    <input
                      id={`affiliation-${idx}`}
                      name={`affiliation-${idx}`}
                      type="text"
                      value={affiliation}
                      onChange={(e) => handleArrayChange('affiliations', idx, e.target.value)}
                      className="flex-1 px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      placeholder={`Affiliation ${idx + 1}`}
                      required
                    />
                    {formData.affiliations.length > 1 && (
                      <button
                        onClick={() => removeItem('affiliations', idx)}
                        className="p-3 text-red-600 hover:bg-red-50 rounded-xl transition"
                        type="button"
                      >
                        <Trash2 className="w-5 h-5" />
                      </button>
                    )}
                  </div>
                ))}
                <button
                  onClick={() => addItem('affiliations')}
                  className="flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium transition"
                  type="button"
                >
                  <Plus className="w-5 h-5" /> Add Affiliation
                </button>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Email Addresses *</label>
                {formData.emails.map((email, idx) => (
                  <div key={idx} className="flex gap-2 mb-3">
                    <input
                      id={`email-${idx}`}
                      name={`email-${idx}`}
                      type="email"
                      value={email}
                      onChange={(e) => handleArrayChange('emails', idx, e.target.value)}
                      className="flex-1 px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      placeholder={`email${idx + 1}@example.com`}
                      required
                    />
                    {formData.emails.length > 1 && (
                      <button
                        onClick={() => removeItem('emails', idx)}
                        className="p-3 text-red-600 hover:bg-red-50 rounded-xl transition"
                        type="button"
                      >
                        <Trash2 className="w-5 h-5" />
                      </button>
                    )}
                  </div>
                ))}
                <button
                  onClick={() => addItem('emails')}
                  className="flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium transition"
                  type="button"
                >
                  <Plus className="w-5 h-5" /> Add Email
                </button>
              </div>

              <div>
                <label htmlFor="abstract" className="block text-sm font-semibold text-gray-700 mb-2">
                  Abstract *
                </label>
                <textarea
                  id="abstract"
                  name="abstract"
                  value={formData.abstract}
                  onChange={(e) => handleChange('abstract', e.target.value)}
                  rows={6}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                  placeholder="Enter your abstract here..."
                  required
                />
              </div>

              <div>
                <label htmlFor="keywords" className="block text-sm font-semibold text-gray-700 mb-2">
                  Keywords
                </label>
                <input
                  id="keywords"
                  name="keywords"
                  type="text"
                  value={formData.keywords}
                  onChange={(e) => handleChange('keywords', e.target.value)}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                  placeholder="machine learning, neural networks, deep learning"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Paper Sections</label>
                {formData.sections.map((section, idx) => (
                  <div key={idx} className="border-2 border-gray-200 rounded-xl p-6 mb-4 hover:border-blue-300 transition">
                    <div className="flex justify-between items-center mb-4">
                      <span className="font-semibold text-gray-700">Section {idx + 1}</span>
                      {formData.sections.length > 1 && (
                        <button
                          onClick={() => removeItem('sections', idx)}
                          className="text-red-600 hover:bg-red-50 p-2 rounded-lg transition"
                          type="button"
                        >
                          <Trash2 className="w-5 h-5" />
                        </button>
                      )}
                    </div>
                    <label htmlFor={`section-${idx}-heading`} className="block text-sm text-gray-600 mb-1">
                      Section Heading
                    </label>
                    <input
                      id={`section-${idx}-heading`}
                      name={`section-${idx}-heading`}
                      type="text"
                      value={section.heading}
                      onChange={(e) => handleSectionChange(idx, 'heading', e.target.value)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl mb-3 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      placeholder="Section Heading"
                    />
                    <label htmlFor={`section-${idx}-content`} className="block text-sm text-gray-600 mb-1">
                      Section Content
                    </label>
                    <textarea
                      id={`section-${idx}-content`}
                      name={`section-${idx}-content`}
                      value={section.content}
                      onChange={(e) => handleSectionChange(idx, 'content', e.target.value)}
                      rows={4}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      placeholder="Section content..."
                    />
                  </div>
                ))}
                <button
                  onClick={() => addItem('sections')}
                  className="flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium transition"
                  type="button"
                >
                  <Plus className="w-5 h-5" /> Add Section
                </button>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">References</label>
                {formData.references.map((reference, idx) => (
                  <div key={idx} className="flex gap-2 mb-3">
                    <textarea
                      id={`reference-${idx}`}
                      name={`reference-${idx}`}
                      value={reference}
                      onChange={(e) => handleArrayChange('references', idx, e.target.value)}
                      rows={2}
                      className="flex-1 px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      placeholder={`Reference ${idx + 1} (IEEE format)`}
                    />
                    {formData.references.length > 1 && (
                      <button
                        onClick={() => removeItem('references', idx)}
                        className="p-3 text-red-600 hover:bg-red-50 rounded-xl transition"
                        type="button"
                      >
                        <Trash2 className="w-5 h-5" />
                      </button>
                    )}
                  </div>
                ))}
                <button
                  onClick={() => addItem('references')}
                  className="flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium transition"
                  type="button"
                >
                  <Plus className="w-5 h-5" /> Add Reference
                </button>
              </div>

              <button
                onClick={generatePDF}
                disabled={generating || !formData.title || !formData.abstract}
                className="w-full bg-gradient-to-r from-blue-600 to-emerald-600 hover:from-blue-700 hover:to-emerald-700 disabled:from-gray-400 disabled:to-gray-400 text-white font-bold py-4 px-6 rounded-xl flex items-center justify-center gap-3 transition-all transform hover:scale-105 disabled:hover:scale-100 shadow-lg"
                type="button"
              >
                <Download className="w-6 h-6" />
                {generating ? 'Generating PDF...' : 'Generate IEEE Paper PDF'}
              </button>
            </div>

            <div className="mt-6 text-center">
              <button
                onClick={() => setFormData({
                  title: 'Deep Learning Approaches for Natural Language Processing',
                  authors: ['John Smith', 'Jane Doe', 'Robert Johnson'],
                  affiliations: ['Department of Computer Science, University of Technology', 'AI Research Lab, Tech Institute'],
                  emails: ['john.smith@university.edu', 'jane.doe@university.edu', 'robert.j@techinst.edu'],
                  abstract: 'This paper presents a comprehensive study of deep learning approaches applied to natural language processing tasks. We explore various neural network architectures including recurrent neural networks, long short-term memory networks, and transformer models. Our experimental results demonstrate significant improvements in accuracy and efficiency compared to traditional methods. We evaluate our approaches on multiple benchmark datasets and provide detailed analysis of the results.',
                  keywords: 'deep learning, natural language processing, neural networks, transformers, machine learning',
                  sections: [
                    {
                      heading: 'Introduction',
                      content: 'Natural language processing has experienced remarkable progress in recent years, primarily driven by advances in deep learning. Traditional approaches relied heavily on hand-crafted features and rule-based systems, which often struggled with the complexity and variability of human language. The introduction of neural network architectures has revolutionized the field, enabling machines to learn representations directly from raw text data.\n\nThis paper investigates the application of various deep learning models to NLP tasks, with a focus on understanding their strengths and limitations. We conduct extensive experiments across multiple datasets and provide insights into best practices for model selection and training.'
                    },
                    {
                      heading: 'Related Work',
                      content: 'The field of deep learning for NLP has evolved rapidly. Early work focused on word embeddings such as Word2Vec and GloVe, which provided dense vector representations of words. Subsequently, recurrent architectures gained popularity for their ability to process sequential data. The introduction of attention mechanisms and transformer models marked a significant breakthrough, leading to state-of-the-art performance on numerous benchmarks.'
                    },
                    {
                      heading: 'Methodology',
                      content: 'Our experimental framework consists of three main components: data preprocessing, model architecture selection, and evaluation metrics. We employ standard tokenization and normalization techniques for text preprocessing. For model architectures, we compare LSTM networks, GRU networks, and transformer-based models. Each model is trained using cross-entropy loss with Adam optimization.'
                    },
                    {
                      heading: 'Results',
                      content: 'Our experiments demonstrate that transformer-based models consistently outperform recurrent architectures across all tested datasets. We observe accuracy improvements ranging from 5% to 15% depending on the specific task. The attention mechanism proves particularly effective for tasks requiring long-range dependencies.'
                    },
                    {
                      heading: 'Conclusion',
                      content: 'This work provides a comprehensive analysis of deep learning approaches for NLP. Our findings confirm the superiority of transformer architectures while highlighting scenarios where simpler models may be sufficient. Future work will explore hybrid architectures and investigate methods for improving computational efficiency.'
                    }
                  ],
                  references: [
                    'A. Vaswani et al., "Attention is all you need," in Advances in Neural Information Processing Systems, 2017, pp. 5998-6008.',
                    'J. Devlin, M. Chang, K. Lee, and K. Toutanova, "BERT: Pre-training of deep bidirectional transformers for language understanding," in Proceedings of NAACL-HLT, 2019, pp. 4171-4186.',
                    'T. Mikolov, K. Chen, G. Corrado, and J. Dean, "Efficient estimation of word representations in vector space," arXiv preprint arXiv:1301.3781, 2013.',
                    'S. Hochreiter and J. Schmidhuber, "Long short-term memory," Neural Computation, vol. 9, no. 8, pp. 1735-1780, 1997.'
                  ]
                })}
                className="text-blue-600 hover:text-blue-700 font-semibold underline transition"
                type="button"
              >
                Load Demo Data
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render different pages based on currentPage state
  if (currentPage === 'landing') {
    return <LandingPage />;
  } else if (currentPage === 'login') {
    return (
      <LoginPage 
        onLogin={handleLogin}
        onFormChange={handleLoginChange}
        loginForm={loginForm}
        onPageChange={setCurrentPage}
      />
    );
  } else if (currentPage === 'signup') {
    return (
      <SignupPage 
        onSignup={handleSignup}
        onFormChange={handleSignupChange}
        signupForm={signupForm}
        onPageChange={setCurrentPage}
      />
    );
  } else if (currentPage === 'generator' && user) {
    return <Amain user={user} onLogout={handleLogout} />;
  }else if (currentPage === 'carrier') {
  return <CareerPage onPageChange={setCurrentPage} />;  // ✅ add this
}

  return <LandingPage />;
};

export default IEEEPaperWebsite;